import React from 'react';
import SectionHeader from '@components/common/SectionHeader';
import InstructionsInfoTabs from './InstructionsInfoTabs';
import InstructionsInfoList, {
  type InstructionsInfoListState,
} from './InstructionsInfoList';
import type {
  InstructionsInfoItem,
  InstructionsInformationData,
  InstructionsInfoTabKey,
} from '@app-types/instructions';
import './InstructionsInformationSection.less';

export interface InstructionsInformationSectionProps {
  data: InstructionsInformationData;
  /** Selected information tab; view state stays in props, not in the data shape. */
  activeTabKey?: InstructionsInfoTabKey;
  onTabClick?: (tabKey: InstructionsInfoTabKey) => void;
  listState?: InstructionsInfoListState;
  isOpeningReport?: boolean;
  onOpenReport?: (item: InstructionsInfoItem) => Promise<string>;
}

/**
 * Information section: header + tabs + disclosure list.
 * See kiro_Instructions_tasks.md §6.
 * Figma: desktop 3175:8698, mobile 3177:10449.
 */
const InstructionsInformationSection: React.FC<InstructionsInformationSectionProps> = ({
  data,
  activeTabKey,
  onTabClick,
  listState,
  isOpeningReport,
  onOpenReport,
}) => (
  <section
    className="instructions-information"
    data-node-id={data.sectionNodeId}
  >
    <SectionHeader
      title={data.title}
      showHelp
      dataNodeId={data.headerNodeId}
      as="h2"
    />
    <div
      className="instructions-information__content"
      data-node-id={data.contentNodeId}
    >
      <InstructionsInfoTabs
        tabs={data.tabs}
        activeTabKey={activeTabKey}
        onTabClick={onTabClick}
        nodeId="3177:10544"
      />
      <InstructionsInfoList
        items={data.items}
        state={listState}
        isOpeningReport={isOpeningReport}
        onOpenReport={onOpenReport}
        nodeId="3176:9091"
      />
    </div>
  </section>
);

export default InstructionsInformationSection;
